export default function isInputTextValid(value: string, isRequired: boolean): boolean {
    if (isRequired) {
        return !!(value && value.trim() != '');
    }
    return true;
}
